import React, { createContext, useContext, useMemo, useState } from "react";
import { baseUrl } from "../utilities/configurations";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";

const RecoveryAccountContext = createContext();

export function useRecoveryAccountContext() {
  return useContext(RecoveryAccountContext);
}

export function RecoveryAccountProvider(props) {
  const [oldMobileErrorMsg, setOldMobileErrorMsg] = useState("");
  const [oldMobileNumber, setOldMobileNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [recoveryMode, setRecoveryMode] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [suffixName, setSuffixName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthDate, setBirthDate] = useState();
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const formatMobileNumber = (e) => {
    const inputVal = e.target.value.replace(/ /g, "");
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    if (inputNumbersOnly.length > 10) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 10);
    }

    setMobileNumber(inputNumbersOnly);
    setMobileErrorMsg("");
  };

  const [helperText, setHelperText] = useState("");

  const [mobileErrorMsg, setMobileErrorMsg] = useState("");

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const isEmailValid = email !== "";

  const isEmailComplete = email !== "" && emailRegex.test(email);

  const isMobileValid = mobileNumber !== "";

  const isMobileComplete =
    mobileNumber !== "" &&
    mobileNumber.startsWith("9") &&
    mobileNumber.length === 10;

  const isCardNumberComplete =
    cardNumber.slice(0, 4).startsWith("1168") &&
    cardNumber.length === 19 &&
    cardNumber !== "";

  const formatOldMobileNumber = (e) => {
    const inputVal = e.target.value.replace(/ /g, "");
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    if (inputNumbersOnly.length > 10) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 10);
    }

    setOldMobileNumber(inputNumbersOnly);
    setOldMobileErrorMsg("");
  };

  const firstNameValidation = (e) => {
    const inputValue = e.target.value;
    const regexPattern = /^[a-zA-ZñÑ\s-]+$/;

    if (inputValue === "" || regexPattern.test(inputValue)) {
      setFirstName(inputValue);
    }
  };

  const middleNameValidation = (e) => {
    const inputValue = e.target.value;
    const regexPattern = /^[a-zA-ZñÑ\s-]+$/;

    if (inputValue === "" || regexPattern.test(inputValue)) {
      setMiddleName(inputValue);
    }
  };

  const lastNameValidation = (e) => {
    const inputValue = e.target.value;
    const regexPattern = /^[a-zA-ZñÑ\s-]+$/;

    if (inputValue === "" || regexPattern.test(inputValue)) {
      setLastName(inputValue);
    }
  };

  const formatCardNumber = (e) => {
    setHelperText("");
    const input = e.target;
    const inputValue = input.value.replace(/\s/g, "");
    const numericValue = inputValue.replace(/\D/g, "");
    const selectionStart = input.selectionStart;
    const isDeleting = e.nativeEvent.inputType === "deleteContentBackward";

    if (/^\d*$/.test(inputValue) && numericValue.length <= 16) {
      const numberWithSpaces = numericValue.replace(/(\d{4})/g, "$1 ").trim();
      setCardNumber(numberWithSpaces);

      let newCaretPosition = selectionStart;

      if (
        isDeleting &&
        selectionStart > 0 &&
        numberWithSpaces[selectionStart - 1] === " "
      ) {
        newCaretPosition--;
      }

      if (
        !isDeleting &&
        selectionStart > 0 &&
        numberWithSpaces[selectionStart - 1] === " "
      ) {
        newCaretPosition++;
      }

      setTimeout(() => {
        input.setSelectionRange(newCaretPosition, newCaretPosition);
      });
    }
  };

  const handleNext = async (e) => {
    if (recoveryMode === "email") {
      if (isEmailValid) {
        if (isEmailComplete) {
          try {
            setIsLoading(true);
            const ip = await axios.get("https://api.ipify.org/?format=json");
            const city = await axios.get(
              `https://ipapi.co/${JSON.stringify(ip.data.ip).replaceAll(
                '"',
                ""
              )}/json/`
            );
            const verifyEmail = await axios.post(
              baseUrl + "/account-recovery/verify-account",
              {
                recoveryType: "Email",
                recoveryValue: email,
                ipAddress: JSON.stringify(ip.data.ip).replaceAll('"', ""),
                location: JSON.stringify(city.data.city).replaceAll('"', ""),
              }
            );
            if (verifyEmail.data.status === true) {
              setUserId(verifyEmail.data.data.userId);
              setIsLoading(false);
              navigate("/recovery-account/email-address/verify-otp");
            }
            if (verifyEmail.data.status === false) {
              //if email doesnt exist or corresponds to an account
              setIsLoading(false);
              setHelperText(
                "Oops! We're unable to verify that email address. Please check if that is your email address."
              );
            }
          } catch (error) {
            console.log(error);
            setIsLoading(false);
          }
        } else {
          setHelperText(
            "Oops! That doesn't look like a valid email address. Please check and enter a valid one."
          );
        }
      } else {
        setHelperText("Required fields cannot be empty.");
      }
    }
    if (recoveryMode === "cardNumber") {
      setIsLoading(true);
      if (isCardNumberComplete) {
        setIsLoading(false);
        navigate("/recovery-account/maxicare-card-number/personal-information");
      } else {
        setHelperText(
          "Oops! That doesn't look like a valid Maxicare Card Number. Please Check and enter a valid one."
        );
        setIsLoading(false);
      }
    }
  };

  const data = useMemo(
    () => ({
      formatOldMobileNumber,
      setOldMobileErrorMsg,
      middleNameValidation,
      firstNameValidation,
      formatMobileNumber,
      setOldMobileNumber,
      lastNameValidation,
      setMobileErrorMsg,
      formatCardNumber,
      setRecoveryMode,
      setMobileNumber,
      setOtpErrorMsg,
      setCardNumber,
      setHelperText,
      setSuffixName,
      setMiddleName,
      setIsLoading,
      setFirstName,
      setBirthDate,
      setLastName,
      handleNext,
      setUserId,
      navigate,
      setEmail,
      setOtp,

      oldMobileErrorMsg,
      isMobileComplete,
      oldMobileNumber,
      isEmailComplete,
      mobileErrorMsg,
      isMobileValid,
      isEmailValid,
      recoveryMode,
      mobileNumber,
      otpErrorMsg,
      suffixName,
      middleName,
      cardNumber,
      helperText,
      isLoading,
      firstName,
      birthDate,
      lastName,
      userId,
      email,
      otp,
    }),
    [
      oldMobileErrorMsg,
      isMobileComplete,
      oldMobileNumber,
      isEmailComplete,
      mobileErrorMsg,
      isMobileValid,
      isEmailValid,
      recoveryMode,
      mobileNumber,
      otpErrorMsg,
      suffixName,
      middleName,
      cardNumber,
      helperText,
      isLoading,
      firstName,
      birthDate,
      lastName,
      userId,
      email,
      otp,
    ]
  );

  return (
    <RecoveryAccountContext.Provider value={data}>
      {props.children}
    </RecoveryAccountContext.Provider>
  );
}

RecoveryAccountProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
